export const filtersConfig = [
  {
    id: 'freeCancellation',
    icon: 'CalendarCheck4'
  },
  {
    id: 'breakfastIncluded',
    icon: 'Bowl'
  },
  {
    id: 'payLater',
    icon: 'CreditCard'
  },
  {
    id: 'priceSort',
    icon: 'SortDescending'
  },
  // Added as a part of c747927f-deal-freeze-srp
  {
    id: 'dealFreeze',
    icon: 'Ice'
  }
] as const

export type FilterKey = (typeof filtersConfig)[number]['id']

export enum FilterSource {
  QuickFilters = 'quickFilters',
  RemoveQuickFilters = 'removeQuickFilters',
  RemoveMoreDealsQuickFilters = 'removeMoreDealsQuickFilters'
}
